<template>
  <div class="changePassword">
    <!-- start change password part -->
    <div class="col-sm-6 the-form">
      <q-linear-progress indeterminate v-if="loading"></q-linear-progress>
      <div class="form-body">
        <!-- form -->
        <q-form @submit.prevent="upDatePassword">
          <!-- form inputs -->
          <label>Current Password</label>
          <q-input type="password" reactive-rules label-color="secondary" filled v-model="formData.old_password" label="Enter Password"/>
          <label>Password</label>
          <q-input type="password" reactive-rules label-color="secondary" filled v-model="formData.password" label="Enter Password"/>
          <label>Confirm Password</label>
          <q-input type="password" reactive-rules label-color="secondary" filled label="Confirm Password"
                   @input="confirmation = null"
                   v-model="formData.confirm_password"/>
          <p v-if="confirmation" style="color: red;">{{confirmation}}</p>
          <!-- form inputs -->
          <!-- send message button -->
          <div class="submit">
            <button-component>Save Changes</button-component>
            <!-- end send message  button -->
          </div>
        </q-form>
        <!-- end form -->
      </div>
    </div>
    <!-- end change password part -->
    <!-- model error -->
    <q-dialog v-model="alert">
      <q-card>
        <q-card-section>
          <div class="text-h6">Alert</div>
        </q-card-section>

        <q-card-section class="q-pt-none">
          <p v-for="formError in formErrors" :key="formError.id">{{formError}}</p>
          <p>{{formDone}}</p>
        </q-card-section>

        <q-card-actions align="right">
          <q-btn flat label="OK" color="primary" v-close-popup />
        </q-card-actions>
      </q-card>
    </q-dialog>
    <!-- end model error -->
  </div>
</template>
<script>
import {HTTP} from "@/http-common";
import ButtonComponent from "@/components/tools/ButtonComponent";
export default {
  data:() => ({
    formData:{
      old_password:'',
      password:'',
    },
    loading:false,
    formDone:'',
    formErrors:[],
    alert:false,
    confirmation: null
  }),
  components: {ButtonComponent},
  methods:{
    upDatePassword(){
      if (this.formData.password == this.formData.confirm_password) {
        this.loading = true;
        this.$API.userProfile.updatePassword(this.formData)
            .then( response => {
              this.loading = false;
              this.formDone = response.data.message;
              this.alert = true;
            })
            .catch( error => {
              this.alert = true;
              this.formErrors = error.response.data.message;
              this.loading = false;
            });
      } else {
        this.confirmation = 'Passwords must match'
      }
    }
  }
}
</script>